import { Injectable } from "@angular/core";
import { PessoaFisica } from "@tivic-team/manager-ts/dist/grl";
import { PessoaFisicaController } from "app/controllers/grl/pessoa-fisica.controller";
import { PessoaFisicaDTO } from "app/model/dtos/grl/pessoa-fisica.dto";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { PessoaFisicaSearch } from "./pessoa-fisica.search";


@Injectable()
export class PessoaFisicaService implements ApiService<PessoaFisica>{
    constructor(
        private _pessoaFisicaController: PessoaFisicaController,
        private _loaderService: LoaderService
    ) { }
    get(...args: number[]): Promise<PessoaFisica> {
        throw new Error("Method not implemented.");
    }
    create(entity: PessoaFisica): Promise<PessoaFisica> {
        throw new Error("Method not implemented.");
    }
    update(entity: PessoaFisica): Promise<PessoaFisica> {
        throw new Error("Method not implemented.");
    }

    async find(pessoaFisicaSearch?: PessoaFisicaSearch): Promise<PessoaFisica[]> {
            this._loaderService.show();
            return await this._pessoaFisicaController.find(pessoaFisicaSearch && pessoaFisicaSearch.getFilters() || null)
                .finally(() => this._loaderService.hide());
    }

    async getPessoaByCPF(nrCpf:string):Promise<PessoaFisicaDTO>{
        this._loaderService.show();
        return this._pessoaFisicaController.getPessoaByCPF(nrCpf).finally(() => this._loaderService.hide());
    }

    async getMotoristas(pessoaFisicaSearch?: PessoaFisicaSearch): Promise<PessoaFisica[]>{
        try{
            return await this._pessoaFisicaController.getMotoristas(pessoaFisicaSearch && pessoaFisicaSearch.getFilters() || null)
            .finally(() => this._loaderService.hide());
        } catch(error){
            this._loaderService.hide();
            return [];
        }
    }
}